<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-menu></app-menu>
  <!-- Pre-warm Ionic overlay custom elements so first open is instant -->
  <ion-modal></ion-modal>
  <ion-alert></ion-alert>
  <ion-toast></ion-toast>
  <ion-action-sheet></ion-action-sheet>
</ion-app>

